import styled from "styled-components";
import GatsbyImg from "gatsby-image";

export const Img = styled(GatsbyImg)`
	width: 100%;
`;
